import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveDynamicComponent as _resolveDynamicComponent, createBlock as _createBlock, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "mx-auto custom-container-forum" }
const _hoisted_2 = { class: "py-1 my-6" }
const _hoisted_3 = { class: "w-full mx-8 text-center" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_TabPanel = _resolveComponent("TabPanel")!
  const _component_TabView = _resolveComponent("TabView")!

  return (_openBlock(), _createElementBlock("main", _hoisted_1, [
    _createElementVNode("h3", _hoisted_2, _toDisplayString(_ctx.$t("forum.listForums.title")), 1),
    _createVNode(_component_TabView, {
      class: "!pb-0 custom-tabsForum",
      onTabChange: _ctx.changeTab,
      lazy: true
    }, {
      default: _withCtx(() => [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.tabs, (tab, i) => {
          return (_openBlock(), _createBlock(_component_TabPanel, { key: i }, {
            header: _withCtx(() => [
              _createElementVNode("div", _hoisted_3, [
                _createElementVNode("span", null, _toDisplayString(tab.title), 1)
              ])
            ]),
            default: _withCtx(() => [
              (_openBlock(), _createBlock(_resolveDynamicComponent(tab.component), { class: "mt-8" }))
            ]),
            _: 2
          }, 1024))
        }), 128))
      ]),
      _: 1
    }, 8, ["onTabChange"])
  ]))
}